// Copyright (C) 2022 Intel Corporation
// Copyright (C) 2023 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import { Config } from '@react-awesome-query-builder/antd';
import asyncFetchUsers from 'components/resource-sorting-filtering/request-users';

import { TaskStatus } from 'cvat-core-wrapper';
import { GetProjectStatusChinese } from 'cvat-core/src/enums';

export const config: Partial<Config> = {
    fields: {
        id: {
            label: '项目标识',
            type: 'number',
            operators: ['equal', 'between', 'greater', 'greater_or_equal', 'less', 'less_or_equal'],
            fieldSettings: { min: 0 },
            valueSources: ['value'],
        },
        name: {
            label: '项目名称',
            type: 'text',
            valueSources: ['value'],
            operators: ['like'],
        },
        assignee: {
            label: '委托人',
            type: 'select',
            valueSources: ['value'],
            operators: ['select_equals'],
            fieldSettings: {
                useAsyncSearch: true,
                forceAsyncSearch: true,
                asyncFetch: asyncFetchUsers,
            },
        },
        owner: {
            label: '拥有者',
            type: 'select',
            valueSources: ['value'],
            operators: ['select_equals'],
            fieldSettings: {
                useAsyncSearch: true,
                forceAsyncSearch: true,
                asyncFetch: asyncFetchUsers,
            },
        },
        updated_date: {
            label: '更新时间',
            type: 'datetime',
            operators: ['between', 'greater', 'greater_or_equal', 'less', 'less_or_equal'],
        },
        status: {
            label: '状态',
            type: 'select',
            valueSources: ['value'],
            operators: ['select_equals', 'select_any_in', 'select_not_any_in'],
            fieldSettings: {
                listValues: [
                    { value: 'annotation', title: `${GetProjectStatusChinese(TaskStatus.ANNOTATION)}` },
                    { value: 'validation', title: `${GetProjectStatusChinese(TaskStatus.VALIDATION)}` },
                    { value: 'completed', title: `${GetProjectStatusChinese(TaskStatus.COMPLETED)}` },
                ],
            },
        },
    },
};

export const localStorageRecentCapacity = 10;
export const localStorageRecentKeyword = 'recentlyAppliedProjectsFilters';
export const predefinedFilterValues = {
    我创建的: '{"and":[{"==":[{"var":"owner"},"<username>"]}]}',
    我负责的: '{"and":[{"==":[{"var":"supervisor"},"<username>"]}]}',
    分配给我: '{"and":[{"==":[{"var":"assignee"},"<username>"]}]}',
    未完成的: '{"!":{"and":[{"==":[{"var":"status"},"completed"]}]}}',
};
